export class ReturnRouteModel {
  route: string;
  queryParams: {};
  constructor (route: string, queryParams: {}) {
    this.route = route;
    this.queryParams = queryParams;
  }
}
